import {CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { LayoutModule } from "./layout/layout.module";
import { DomainsRoutingModule } from "./domains/domains-routing.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AuthInterceptor } from "./domains/auth/services/auth-interceptor.service";
import { registerLocaleData } from "@angular/common";
import localePt from '@angular/common/locales/pt';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {SignedInGuard} from "./domains/auth/services/signed-in-guard.service";
import {SignedOutGuard} from "./domains/auth/services/signed-out-guard.service";
import {CoreModule} from "./core/core.module";

// import { MatNativeDateModule } from '@angular/material/core';

registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    DomainsRoutingModule,
    LayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    CoreModule,
    // MatNativeDateModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide:  DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    SignedInGuard,
    SignedOutGuard,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
